var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label-width":_vm.itemRender.width,"label":_vm.itemRender.label}},[_c('div',{staticClass:"link",class:_vm.itemRender.link ? 'disabled' : ''},[_vm._v(" "+_vm._s(_vm.itemRender.content)+" "),_c('span',{staticStyle:{"margin-left":"2px"}},[_vm._v(_vm._s(_vm.itemRender.link ? ">" : ""))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }